import React from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { 
  LayoutDashboard, 
  MapPin, 
  BookOpen, 
  History, 
  CreditCard, 
  Settings, 
  Mail,
  LogOut,
  Gamepad2,
  Rocket
} from 'lucide-react';


export default function DashboardLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const navItems = [
  { path: '/dashboard', label: 'Dashboard', icon: <LayoutDashboard size={20} /> },
  { path: '/dashboard/venues', label: 'Venues', icon: <MapPin size={20} /> },
  { path: '/dashboard/templates', label: 'Quizzler Official Games', icon: <BookOpen size={20} /> },
  { path: '/dashboard/my-games', label: 'My Custom Games', icon: <Gamepad2 size={20} /> },
  { path: '/dashboard/history', label: 'Game History', icon: <History size={20} /> },
  { path: '/dashboard/subscription', label: 'Subscription', icon: <CreditCard size={20} /> },
  { path: '/dashboard/settings', label: 'Settings', icon: <Settings size={20} /> },
  { path: '/dashboard/messages', label: 'Messages', icon: <Mail size={20} /> },
];

  return (
    <div className="flex h-screen bg-gray-100">
      {/* Sidebar */}
      <aside className="w-64 bg-white shadow-lg">
        {/* Logo */}
        <div className="p-6 border-b">
  <div className="mb-2">
    <img 
      src="https://quizzlertrivia.com/img/quizzler_logo.png" 
      alt="Quizzler" 
      style={{ height: '30px', width: 'auto' }}
    />
  </div>
  <p className="text-sm text-gray-600">Host Dashboard</p>
</div>

        {/* User Info */}
        <div className="p-4 border-b bg-gray-50">
          <p className="text-sm font-semibold text-gray-700">{user?.name}</p>
          <p className="text-xs text-gray-500">{user?.email}</p>
        </div>

        {/* Navigation */}
        <nav className="p-4">
          {navItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center px-4 py-3 mb-2 rounded-lg transition ${
                  isActive
                    ? 'bg-teal-100 text-teal-700 font-semibold'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                <span className="mr-3">{item.icon}</span>
                {item.label}
              </Link>
            );
          })}
        </nav>

        {/* Launch Game Button */}
        <div className="p-4">
          
            <a href="https://gamehost.quizzlertrivia.com"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2 w-full bg-orange-500 text-white px-4 py-3 rounded-lg font-semibold hover:bg-orange-600 transition"
          >
            <Rocket size={20} />
            Launch Game
          </a>
        </div>
        

        {/* Logout Button */}
        <div className="absolute bottom-0 w-64 p-4 border-t">
          <button
            onClick={handleLogout}
            className="w-full px-4 py-3 text-left text-red-600 hover:bg-red-50 rounded-lg transition flex items-center"
          >
            <span className="mr-3"><LogOut size={20} /></span>
            Logout
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
}
